<template>
  <ss-modal
    v-show="isModalVisible"
    title="Title"
    class="xs"
    intro="bounceIn"
    outro ="bounceOut">
    <!-- HEADER -->
    <div slot="modal-header">
      <p class="h5 mt-0 mb-2">
        Status zabezpieczenia {{ guarantee ? guarantee.id : '' }}
      </p>
      <template v-if="guarantee && guarantee.id">
        <p class="mt-0 mb-1">Aktualny status:
          <strong :class="statusClass">
            {{ currentStatus ? currentStatus.label : '-' }}
          </strong>
        </p>
        <p class="my-0">
          Data modyfikacji statusu:
          <strong
            :class="{
              'text-primary': guarantee && guarantee.status_date,
              'text-warning': guarantee && !guarantee.status_date,
              'bold': true
            }">
            {{ guarantee.status_date || '-' }}
          </strong>
        </p>
      </template>
      <i class="close" @click="closeModal(false)" style="top: 30px;"></i>
    </div>
    <!-- BODY -->
    <div slot="modal-body" >
      <template v-if="guarantee && guarantee.id">
        <div class="form-group">
          <label>Status zabezpieczenia</label>
          <d-select
            name="status"
            v-model="newStatus"
            v-validate="'required'"
            :class="{'is-invalid' : errors.has('status')}">
            <option
              :value="null"
              label="--Wybierz status"
              default
              disabled>
            </option>
            <option
              v-for="optionItem in availableStatuses"
              :value="optionItem.value">
              {{ optionItem.label }}
            </option>
          </d-select>
          <div class="invalid-feedback">
            {{ errors.first('status') }}
          </div>
        </div>

        <div class="form-group">
          <label>Data zmiany statusu</label>
          <ss-date
            type="text"
            name="status_date"
            v-model="newStatusDate"
            v-validate="'required'"
            placeholder="Wybierz datę"
            :class="{'is-invalid' : errors.has('status_date')}"/>
          <div class="invalid-feedback">
            {{ errors.first('status_date') }}
          </div>
        </div>
      </template>
    </div>
    <!-- FOOTER -->
    <div slot="modal-footer">
      <d-button
        @click.prevent="closeModal(false)"
        :class="{ disabled: actionInProgress }"
        theme="danger">
        <i class="material-icons">close</i> Zamknij
      </d-button>
      <d-button
        @click.prevent="validateForm"
        :class="{ isLoading: actionInProgress }"
        theme="success"
        class="ml-3">
        <i class="material-icons">save</i> Zapisz
      </d-button>
    </div>
  </ss-modal>
</template>

<script>
import SsModal from '@/components/common/SsModal';
import SsDate from '@/components/common/SsDate';
import GuaranteeUtils from '@/utils/guarantee.js';
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'GuaranteeStatusModal',
  components: {
    SsModal,
    SsDate
  },
  props: {
    scheduleId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    availableStatuses () {
      if (!this.guarantee) {
        return [];
      }

      return GuaranteeUtils.getAvailableStatusesForType(this.guarantee.type);
    },
    currentStatus () {
      if (!this.guarantee || !this.guarantee.status) {
        return null;
      }

      let statusFound = this.availableStatuses.find(item => item.value === this.guarantee.status);

      return statusFound;
    },
    statusClass () {
      let classList = ['bold'];
      if (this.currentStatus) {
        classList.push(this.currentStatus.class);
      } else {
        classList.push('text-warning');
      }

      return classList.join(' ');
    }
  },
  data () {
    return {
      actionInProgress: false,
      guarantee: null,
      isModalVisible: false,
      newStatus: null,
      newStatusDate: null
    }
  },
  methods: {
    validateForm () {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          return;
        }

        this.updateStatus();
      });
    },
    updateStatus () {
      this.actionInProgress = true;

      FormUtils.submit(this, {
        endpoint: '/api/payment-guarantees/change-status-payment-guarantee',
        formData: this.prepareFormDataToSend(),
        successTitle: 'Status zabezpieczenia.',
        successText: 'Status zabezpieczenia został zapisany.',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Zmiana statusu zabezpieczenia nie powiodła się. Spróbuj ponownie.',
        successAction: (response) => {
          this.actionInProgress = false;
          this.closeModal(true);
        },
        failAction: (error) => {
          this.actionInProgress = false;
          console.log(error);
        }
      });
    },
    prepareFormDataToSend () {
      return {
        id: this.guarantee.id,
        schedule_id: this.scheduleId,
        status: this.newStatus,
        status_date: this.newStatusDate
      }
    },
    showModal (guarantee) {
      this.resetView();

      this.newStatus = guarantee.status;
      this.newStatusDate = Vue.getCurrentDate();
      this.guarantee = JSON.parse(JSON.stringify(guarantee));

      Vue.nextTick(() => {
        this.isModalVisible = true;
      })
    },
    closeModal (shouldReload = false) {
      this.isModalVisible = false;
      if (shouldReload) {
        this.$bus.$emit('reload-contract');
        this.$bus.$emit('contract-reload-guarantees');
      }
    },
    resetView () {
      this.guarantee = null;
      this.newStatus = null;
      this.newStatusDate = null
      this.actionInProgress = false;
    }
  }
}
</script>
